
import { createClient } from '@supabase/supabase-js';

// You will need to create separate Supabase projects for staging and production
// and set these environment variables in your Vercel project settings
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://tkrrgpbntaqiupgcayjm.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRrcnJncGJudGFxaXVwZ2NheWptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAzNzI5NDEsImV4cCI6MjA1NTk0ODk0MX0.OGFqmh6JQDjL3tMt1_eBnB42llz2bRYCfCcF66xtBjE';

// Add environment indicator to console in non-production environments
const isDev = import.meta.env.MODE !== 'production';
if (isDev) {
  console.log(`🔧 Running in ${import.meta.env.MODE} environment`);
  // You could add visual indicators for non-production environments here
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'sakuwari-auth',
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  }
});

// Add a helper to check environment
export const isProduction = () => import.meta.env.MODE === 'production';
export const isStaging = () => import.meta.env.MODE === 'staging';
export const isDevelopment = () => import.meta.env.MODE === 'development';

// Channel management for realtime subscriptions
const channels: Record<string, any> = {};

export const registerChannel = (name: string, channel: any) => {
  channels[name] = channel;
  return channel;
};

export const getChannel = (name: string) => {
  return channels[name];
};

export const cleanupChannel = (name: string) => {
  if (channels[name]) {
    supabase.removeChannel(channels[name]);
    delete channels[name];
    return true;
  }
  return false;
};

// Online status detection
export const isOnline = () => {
  return navigator.onLine;
};

// Check if user is admin
export const isUserAdmin = async (userId: string): Promise<boolean> => {
  if (!userId) return false;
  
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('role, username')
      .eq('id', userId)
      .single();
    
    if (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
    
    console.log('Admin check data:', data);
    
    // User is admin if they have admin role or if their username is 'admin' or 'andrew'
    return data?.role === 'admin' || data?.username === 'admin' || data?.username === 'andrew';
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};
